import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-navy text-white mt-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo-aspire-icon-256.png" alt="Aspire Collective Partners LLC" className="h-10 w-10 object-contain bg-white rounded-md p-1" />
            <span className="font-display text-lg">Aspire Collective Partners LLC</span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">
            Nationwide cash home buyers. Any condition. Any situation. No fees, no repairs, flexible closing timeline.
          </p>
          <address className="not-italic mt-4 flex items-start gap-2 text-sm text-white/70 leading-relaxed" data-testid="footer-address">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 mt-[3px] shrink-0 text-money" aria-hidden="true">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <span>
              1401 21st Street, Suite R<br />
              Sacramento, CA 95811
            </span>
          </address>
        </div>
        <div>
          <h4 className="font-display text-base mb-3">Situations</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/sell-probate-house" className="hover:text-money">Sell a Probate House</Link></li>
            <li><Link to="/stop-foreclosure" className="hover:text-money">Stop Foreclosure</Link></li>
            <li><Link to="/sell-inherited-house" className="hover:text-money">Inherited House</Link></li>
            <li><Link to="/sell-house-tax-lien" className="hover:text-money">Tax Lien / Delinquent</Link></li>
            <li><Link to="/sell-house-as-is" className="hover:text-money">Sell As-Is</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-base mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/" className="hover:text-money">Home</Link></li>
            <li><Link to="/privacy" className="hover:text-money">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-money">Terms and Conditions</Link></li>
            <li><Link to="/admin/login" className="hover:text-money">Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-base mb-3">Talk to us</h4>
          <a href="tel:+16149664283" className="block bg-money text-white text-center px-4 py-3 rounded-md font-semibold" data-testid="footer-call-btn">
            Call (614) 966-4283
          </a>
          <a href="sms:+16149664283" className="block mt-3 border border-white/30 text-center px-4 py-3 rounded-md font-semibold hover:bg-white/10" data-testid="footer-sms-btn">
            Text Us
          </a>
          <a href="mailto:carlos@aspirecollectivepartnersllc.com" className="block mt-3 text-sm text-white/80 hover:text-money break-all" data-testid="footer-email-link">
            carlos@aspirecollectivepartnersllc.com
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/60">
        &copy; {new Date().getFullYear()} Aspire Collective Partners LLC. All rights reserved. Nationwide U.S.
      </div>
    </footer>
  );
}
